



























import Vue from 'vue';

import ShowListItem from './show-list-item.vue';
import { IShow } from '../../../../../shared/types';

export default Vue.extend({
  name: 'ShowList',

  components: {
    ShowListItem,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    shows: {
      type: Array,
      default: () => [] as IShow[],
    },

    rows: {
      type: Boolean,
      default: true,
    },
  },
});
